<template>
  <div>
    <!-- <div id="remote-container"></div> -->
    <!-- <audio id="localVideo"  controls autoplay muted></audio> -->
    <!-- <audio id="remote" controls autoplay></audio> -->
    <NoEventFound v-if="callWaitingNotFire" @close="handleExit"/>
    <CallSearching v-if="callSearching" @close="handleExit" :internetDisconnect="internetDisconnect"/>
    <CallMatch
      v-if="Match"
      @callDecline="callDecline"
      @callAccept="callAccept"
      :first_caller_id="first_caller_id"
      :internetDisconnect="internetDisconnect"
      :showReconnect="showReconnect"
      :callStatus="callStatus" 
    /> 
    <!-- {{timeleftforDisconnect}} -->
    <CallReceived  
      v-if="callReceived"
      @CallDisconnect="CallDisconnect"
      @Mute="handleMic"
      @Speaker="handleSpeaker"
      :Minutes="Minutes"
      :Seconds="Seconds"
      :callStatus="callStatus"
      :remoteStreamNotFound="remoteStreamNotFound"
      :reconnecting_status="reconnecting_status"
      :speakerOn="speakerOn"
      :micOn="micOn"
      :message="message"
      :callerImg="callerImg"
      :internetDisconnect="internetDisconnect"
      :showReconnect="showReconnect" 
    />
    <CallToCaller
      v-if="callWaiting" 
      :callerImg="callerImg"
      :matchDetails="matchDetails"
      :internetDisconnect="internetDisconnect"
      :userPosition="userPosition"
      :message="message"
      :findAnotherCallBtnProp="findAnotherCallBtnProp"
      @handleCalltoCaller="handleCalltoCaller"
      @handleExit="handleExit"
    />
    <Toaster :dataValue="toasterData" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  startCall,
  agoraInit,
  permissionForCall,
  callUnsubscribe,
  setCallVolume,
  callMake
} from "../../utils/helper";
import Toaster from "../../components/common/Toaster";
import CallSearching from "../../components/common/CallSearching";
import CallToCaller from "../../components/common/CallToCaller";
import CallMatch from "../../components/common/CallMatch";
import CallReceived from "../../components/common/CallReceived";
import NoEventFound from "../../components/common/NoEventFound";
export default {
  name: "CallScreen2",
  components: {
    CallSearching,
    CallToCaller,
    CallMatch,
    CallReceived,
    Toaster,
    NoEventFound
  },
  computed: {
    ...mapState(["maxSecondForcall"])
  },
  watch: {
    reconnecting_status: function(newVal, oldVal){
      if(!this.callSearching && newVal === 'user_disconnected'){
        if(this.timeInterval){
          clearInterval(this.timeInterval);
          this.$store.commit('TimeDuration', 0)
          callUnsubscribe(this);
          this.$router.replace("/call-history");
        }
        if (this.removeWaiting) {
          this.handleRemoveWaiting();
        }
        if(!this.internetDisconnect && (this.backFireEvent === 'disconnect')){
          if(this.getShowReconnect){
            this.CallDisconnect()
            callUnsubscribe(this);
            this.$router.replace("/call-history");
          }
        }else{
          clearInterval(this.timeInterval);
          this.$store.commit('TimeDuration', 0)
          callUnsubscribe(this);
          this.$router.replace("/call-history");
        }
      }else if(this.callSearching && newVal === 'user_disconnected'){
         this.$router.replace("/call-history");
      }
      if(newVal === 'reconnect_user'){
        clearInterval(this.IntervalforDisconnection)
        this.timeleftforDisconnect = 25;
      }
    }
  },
data() {
    return {
      timeLeft: null,
      callWaiting: false,
      callSearching: false,
      calltoCaller: false,
      timeStamp: null,
      message: null,
      Match: false,
      callReceived: false,
      toasterData: {},
      identifier: null,
      first_caller_id: null,
      client: {},
      remoteStreamNotFound: true,
      callStatus: "initial",
      Seconds: "00",
      Minutes: "00",
      remoteStream: {},
      uStreamId: null,
      room_id: null,
      timeInterval: null,
      timerId: null,
      localStream: {},
      micOn: true,
      message: null,
      speakerOn: true,
      speakerMessage: null,
      removeWaiting: false,
      callWaitingNotFire: false,
      userPosition: null,
      reconnecting_status: " ",
      IntervalforDisconnection: null,
      timeleftforDisconnect: null,
      showReconnect: false,
      internetDisconnect: false,
      receivedCall: false,
      callInitiated: false,
      backFireEvent: " ",
      declineformButton: false,
      diconnectfromButton: false,
      callerImg:"",
      findAnotherCallBtnProp: false,
      callerTocallerSetTimeOut: null,
      callerTocallerStatus:'',
      getShowReconnect: false,
      matchDetails: null
    }
  },
  sockets: {
    new_connection: function(data){
      // this.$router.replace("/call-history");
    },
    reconnect_call_initiated: function(data){
      this.showReconnect = false
      this.getShowReconnect = false
      this.reconnecting_status = 'reconnect_user'
      this.timeleftforDisconnect = 25;
      this.internetDisconnect = false
      if(!this.callInitiated){
          this.callerImg = data.img
          if(data.identifier === 1){
            this.callWaiting = true
            this.callStatus = "call_received"
            this.callerTocallerStatus = "call_received"
            this.backFireEvent = 'disconnect'
            this.Match = false;
            this.removeWaiting = true
            this.findAnotherCallBtnProp = true
          }else{
            this.Match = true;
            this.callWaiting = false;
            this.backFireEvent = 'decline' 
            this.callStatus = "initiated"
          }
          this.callSearching = false;
          this.callInitiated = true
          this.first_caller_id = data.first_caller_id;
          this.identifier = data.identifier;
          this.message = data.message;
          this.timeStamp = data.timestamp;
          this.room_id = data.room_id;
          this.callSearching = false;
          this.removeWaiting = false;
          this.callWaitingNotFire = false;
          setTimeout(()=>{
          if (data.identifier === 1) {
            this.callWaiting = false
            this.startCalling();
            this.Match = false;
            this.callReceived = true; 
          }
          },3000) 
          clearInterval(this.timerId);
      }
      this.callStatus = "call_initiate"
    }, 
    reconnect_communication: function(data){
      this.getShowReconnect = false
      this.removeWaiting = true
      this.reconnecting_status = 'reconnect_user'
      this.timeleftforDisconnect = 25;
      this.showReconnect = false
      this.internetDisconnect = false
      if(!this.receivedCall){
        this.backFireEvent = 'disconnect'
        this.callStatus = "call_received" 
        this.startCalling();
        this.Match = false;
        this.callReceived = true;
        this.callWaitingNotFire = false;
      }
      this.callStatus = "call_initiate"
    },
    connection_searching: function(data) {
      // It get listen during the caller is in waiting state.
      // this.timer();
      this.displayTimeLeft = true;
      this.callSearching = true;
      this.callWaitingNotFire = false;
      this.removeWaiting = true;
    }, 
    show_reconnection: function(data){
      this.getShowReconnect = true
      this.callStatus = " ";
      this.showReconnect = true
      this.remoteStreamNotFound = false
      this.internetDisconnect = true
      this.timerForDisconnectionAfterWaitingReconnection()
    },
    caller_waiting_queue: function(data) {
      // It get listen when the caller is waiting for other caller for call.
      this.removeWaiting = true;
      this.callSearching = true;
      this.callWaitingNotFire = false;
      this.callWaiting = false
    },
    call_initiated_error: function(data) {
      // it get listen during call initiating error.
      this.toasterData = {
        status: true,
        msg: data.message,
        timeoutMs: "5000",
        color: "#330028"
      };
      this.callWaitingNotFire = false;
      this.callSearching = true;
      this.$router.replace("/call-history");
    },
    call_initiated: function(data) {
      // It get listen after firing initiated_dost_call event
      this.callerImg = data.img
      if(data.identifier === 1){ 
        this.callWaiting = true
        this.callerTocallerStatus = "call_received" 
        this.callStatus = "call_received"
        this.backFireEvent = 'disconnect'
        this.Match = false;
        this.removeWaiting = true
        this.findAnotherCallBtnProp = true
      }else{
        this.Match = true;
        this.callWaiting = false;
        this.backFireEvent = 'decline' 
        this.callStatus = "initiated"
      }
      this.callSearching = false;
      this.callInitiated = true
      this.first_caller_id = data.first_caller_id;
      this.identifier = data.identifier;
      this.message = data.message;
      this.timeStamp = data.timestamp;
      this.room_id = data.room_id;
      this.matchDetails = data.match
      this.callSearching = false;
      this.removeWaiting = false;
      this.callWaitingNotFire = false;
      this.callerTocallerSetTimeOut = setTimeout(()=>{
      if (data.identifier === 1) {
        this.callWaiting = false
        this.startCalling();
        // this.countUpCounter();
        this.Match = false;
        this.callReceived = true; 
      }
      },3000) 
      clearInterval(this.timerId);
    },
    call_received: function(data) {
      // It get listen after firing accept_dost_call event.
      // this.backFireEvent = 'disconnect'
      this.callStatus = "call_received"
      this.removeWaiting = true  
      this.receivedCall = true
      this.backFireEvent = 'disconnect'
      this.startCalling();
      this.Match = false;
      this.callReceived = true;
      this.callWaitingNotFire = false;
    }, 
    call_declined: function(data) {
      // It get listen after firing decline_dost_call event before the call accept.
      this.$router.replace('/call-history');
      this.callWaitingNotFire = false;
    }, 
    decline_dost_call: function(data) {
      // It get listen after firing disconnect_dost_call event during the call between caller to caller.
      this.$router.replace('/call-history');
      this.callWaitingNotFire = false;
    },
    call_disconnected: function(data) {
      // It get listen after firing disconnect_dost_call event during the call between caller to operator.
      if(this.callerTocallerSetTimeOut){
         clearTimeout(this.callerTocallerSetTimeOut);
      }
      this.callStatus = "call_end";
      this.callWaitingNotFire = false;    
      clearInterval(this.timeInterval);
      this.$store.commit('TimeDuration', 0)
      this.$router.replace('/call-history');
      this.handleRemoveWaiting()
      callUnsubscribe(this); // Unsubscribe Remote Stream of call and leave client
    },
    position: function(data) {
      this.userPosition = data.position;
    }
  },
  methods: {
    handleRemoveWaiting() {
      this.$store.dispatch({
        type: "removeWaitingUser",
        payload: { x_auth_id: this.$cookie.get("X-Auth-Id") }
      });
    },
    timerForDisconnectionAfterWaitingReconnection() {
        // It runs during calling is waiting.
        this.reconnecting_status = 'user_waiting_for_reconnection'
        if(this.IntervalforDisconnection){
          clearInterval(this.IntervalforDisconnection)
        }
        this.timeleftforDisconnect = 25;
        this.IntervalforDisconnection = setInterval(() => {
          if (this.timeleftforDisconnect === 0) {
            clearInterval(this.IntervalforDisconnection)
            // clearInterval(this.timeInterval)
            this.reconnecting_status = 'user_disconnected'
          } else {
            this.timeleftforDisconnect--;
          }
        }, 1000);
      },
    handleExit() {
      if(this.callerTocallerSetTimeOut){
         this.CallDisconnect()
      }
      if(window.rtsee){
        window.rtsee.close()
      }
      this.handleRemoveWaiting();
      this.$router.replace('/call-history');
    },
     async startCalling() { 
      // for call initiate 
      const ENDPOINT = 'webrtc.services-money91.com'
      window.rtsee = new window.RTSee()
      await window.rtsee.broadcast({
          debug: true,
          id: this.$cookie.get("X-Auth-Id"),
          endpoint: ENDPOINT,
          video: true,
          save: false,
          roomId: this.room_id,
          watch: (state) => {
            console.log(`State changed----sart call-- : ${state}`)
            if(state === 'remote_added'){
               this.callStatus = "call_initiate";
               this.remoteStreamNotFound = false
               if(this.$route.name === 'CallingScreen'){
                   this.countUpCounter();
                }
            }
            if(state === 'remote_removed'){
              this.handleExit()
            }
      }})
    },
    callDecline() {
      this.declineformButton = true
      this.$socket.emit("decline_dost_call", {
        // It get emit for decline the call
        timestamp: this.timeStamp,
        x_auth_id: this.$cookie.get("X-Auth-Id"),
        code:
          this.identifier === 1
            ? this.first_caller_id === this.$cookie.get("X-Auth-Id")
              ? 2
              : 3
            : 1
      });

      this.handleRemoveWaiting();
    },
    callAccept() {
      // It get emit for Accepting the call
      this.$socket.emit("accept_dost_call", {
        timestamp: this.timeStamp,
        x_auth_id: this.$cookie.get("X-Auth-Id"),
        code: this.identifier
      });
    },
    CallDisconnect() {
      // It get emit for diconnect the call
      this.diconnectfromButton = true
      this.$socket.emit("disconnect_dost_call", {
        timestamp: this.timeStamp,
        x_auth_id: this.$cookie.get("X-Auth-Id"),
        code:
          this.identifier === 1
            ? this.first_caller_id === this.$cookie.get("X-Auth-Id")
              ? 2
              : 3
            : 1
      });
      // this.handleRemoveWaiting()
    },
    handleCalltoCaller() {
      // It get emit for enabling the call permission for caller.
      this.$socket.emit("user_permission_for_making_user_call", {
        x_auth_id: this.$cookie.get("X-Auth-Id")
      });
    },
    handleSpeaker() {
      // It handles the speaker mode during the call.
      if (!this.speakerOn) {
        // setCallVolume(this, 100);
        this.speakerOn = true;
      } else {
        // setCallVolume(this, 30);
        this.speakerOn = false;
      }
    },
    handleMic() {
      // It handles the mic on off mode during the call.
      // this.localStream.isAudioOn()
      //   ? this.localStream.disableAudio()
      //   : this.localStream.enableAudio();

      this.micOn = !this.micOn;
      let senderList = window.rtsee.pc.getSenders()
      console.log('===senderList',senderList)
      senderList.map((sender, index)=>{
        console.log('=sender.track.kind==',sender.track.kind)
        console.log('==sender=',sender.track.enabled)
        if(sender.track.kind === 'audio'){
          sender.track.enabled = this.micOn;
        }
      })
      this.toasterData = {
        status: true,
        msg: this.micOn ? this.$t("Muteoff") : this.$t("Muteon") ,
        timeoutMs: "5000",
        color: "#330028"
      };
    },
    hide() {
      this.$emit("handlehide");
    },
    timer() {
      // It runs during calling is waiting.
      this.timeLeft = 20;
      this.callSearching = true;
      this.timerId = setInterval(() => {
        if (this.timeLeft == 0) {
          clearTimeout(this.timerId);
          this.callWaiting = true;
          this.callSearching = false;
        } else if (this.timeLeft === 3) {
          this.timeLeft--;
        } else {
          this.timeLeft--;
        }
      }, 1000);
    },
    countUpCounter() { 
      // It shows timer during the call.
      let totalSeconds = this.$store.state.timeDuration;
      if(this.timeInterval){
         clearInterval(this.timeInterval);
      }
      this.timeInterval = setInterval(() => {
        ++totalSeconds;
        this.$store.commit('TimeDuration', totalSeconds)
        this.Seconds = pad(totalSeconds % 60);
        this.Minutes = pad(parseInt(totalSeconds / 60));
        // if (this.maxSecondForcall - totalSeconds === 3) {
        //   this.CallDisconnect();
        // }
      }, 1000);
      const pad = val => {
        let valString = val + "";
        if (valString.length < 2) {
          return "0" + valString;
        } else {
          return valString;
        }
      };
    }
  },
  beforeDestroy() {
    // It runs when the component get unmount from the DOM.
    this.$cookie.set('DisconnectingStatus', 'true')
    this.getShowReconnect = false
    if(this.timeInterval){
      clearInterval(this.timeInterval);
      this.$store.commit('TimeDuration', 0)
    }
    if(this.IntervalforDisconnection){
      clearInterval(this.IntervalforDisconnection)
    }
    if (this.removeWaiting) {
      this.handleRemoveWaiting();
    }
    if (this.internetDisconnect && this.showReconnect && this.timeStamp){
      this.CallDisconnect(); // call disconnect during call if component get unmount
      callUnsubscribe(this);
    }   
    if(!this.internetDisconnect && !this.diconnectfromButton && (this.callStatus === "call_received" || this.callStatus === "call_initiate")) {
      this.CallDisconnect(); // call disconnect during call if component get unmount
      callUnsubscribe(this);
    }
    if(this.internetDisconnect && !this.diconnectfromButton && (this.callStatus === "call_received" || this.callStatus === "call_initiate")) {
      callUnsubscribe(this); // call disconnect during call if component get unmount
    }
    if(!this.internetDisconnect && !this.diconnectfromButton){
       if(this.backFireEvent === 'decline'){
          this.callDecline()
      }
    }
  },
  mounted(){
    // this.$cookie.set('DisconnectingStatus', 'false')
    this.$socket.on('disconnect', () => {
       this.callStatus = "";
       this.callerTocallerStatus = ""
       this.internetDisconnect = true
       this.remoteStreamNotFound = false
       this.showReconnect = true
        if(this.IntervalforDisconnection){
          clearInterval(this.IntervalforDisconnection)
        } 
       this.timerForDisconnectionAfterWaitingReconnection()
       this.$socket.on('reconnect', () => {
       this.remoteStreamNotFound = true
       this.internetDisconnect = false
       //  this.reconnecting_status = 'reconnect_user'
       //  this.timeleftforDisconnect = 25;
    })
    })
  },
  created() {
    // It runs when the component get mount on DOM
    if (this.$route.query.callSearch === "true") {
      this.callWaitingNotFire = true;
    }
    permissionForCall(); // This function is used for allow permisson for call using JSbridge
    agoraInit(this); // Initiating Agora
  }
};
</script>
